class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.section = this.closest('.shopify-section');

    this.parentsWithChildren = this.querySelectorAll('.mega-menu__link--level-1');
    this.parentsWithChildren.forEach((parent) => {
      parent.addEventListener('mouseenter', this.onParentHover.bind(this));
    });

    let items = document.querySelector('.header__inline-menu').querySelectorAll('details');

    items.forEach((item) => {
      item.addEventListener('mouseover', () => {
        item.setAttribute('open', true);
        item.querySelector('ul').addEventListener('mouseleave', () => {
          item.removeAttribute('open');
        });
        item.addEventListener('mouseleave', () => {
          item.removeAttribute('open');
        });
      });

      item.addEventListener('click', async (e) => {
        window.location.href = item.dataset.url;
      });
    });
  }

  onParentHover(event) {
    const megaMenuLink = event.currentTarget.getAttribute('data-mega-menu-link');
    const megaChildren = document.querySelectorAll('.mega-child');

    megaChildren.forEach((child) => {
      child.classList.add('hidden'); // Hide all mega children
    });

    const targetMegaChild = document.querySelector(`.mega-child[data-mega-menu-link="${megaMenuLink}"]`);
    if (targetMegaChild) {
      targetMegaChild.classList.remove('hidden'); // Show the targeted mega child
    }

    // New code to remove 'hidden' from .mega-menu-right if the hovered item has children
    const megaMenuRight = this.querySelector('.mega-menu-right');
    if (event.currentTarget.classList.contains('has-children')) {
      megaMenuRight.classList.remove('hidden');
    } else {
      megaMenuRight.classList.add('hidden');
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    this.mainDetailsToggle.open == true
      ? this.section.classList.add('header-details-open')
      : this.section.classList.remove('header-details-open');

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
